/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * カスタム計算結果の存在チェックレスポンス
 * @export
 * @interface CustomCalcResultExistsResponse
 */
export interface CustomCalcResultExistsResponse {
    /**
     * ファイルが存在するかどうか
     * @type {boolean}
     * @memberof CustomCalcResultExistsResponse
     */
    fileExists: boolean;
}

/**
 * Check if a given object implements the CustomCalcResultExistsResponse interface.
 */
export function instanceOfCustomCalcResultExistsResponse(value: object): value is CustomCalcResultExistsResponse {
    if (!('fileExists' in value) || value['fileExists'] === undefined) return false;
    return true;
}

export function CustomCalcResultExistsResponseFromJSON(json: any): CustomCalcResultExistsResponse {
    return CustomCalcResultExistsResponseFromJSONTyped(json, false);
}

export function CustomCalcResultExistsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCalcResultExistsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileExists': json['file_exists'],
    };
}

export function CustomCalcResultExistsResponseToJSON(json: any): CustomCalcResultExistsResponse {
    return CustomCalcResultExistsResponseToJSONTyped(json, false);
}

export function CustomCalcResultExistsResponseToJSONTyped(value?: CustomCalcResultExistsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_exists': value['fileExists'],
    };
}

